// extracted by mini-css-extract-plugin
export default {"test-form":"EMXa52tHMq","testForm":"EMXa52tHMq"};
    if(module.hot) {
      // 1650538088561
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  